import { NoDataMessageProps } from '../../types';
import { Box, Typography } from '@mui/material';

/**
 * Component for displaying no data message
 * Feature: No data state handling
 * When: Required data is missing
 * Then: Show no data message
 */
export function NoDataMessage({ message, height }: NoDataMessageProps) {
  return (
    <Box
      sx={{
        height: height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: (theme) => theme.palette.grey[50],
        borderRadius: 1,
      }}
    >
      <Typography
        variant="body1"
        sx={{
          color: (theme) => theme.palette.brand?.['forest-green'] || theme.palette.text.secondary,
          textAlign: 'center',
        }}
      >
        {message}
      </Typography>
    </Box>
  );
}
